import { render } from "./IncidenciasStreamlined.vue?vue&type=template&id=772c10ca&scoped=true"
import script from "./IncidenciasStreamlined.vue?vue&type=script&lang=ts"
export * from "./IncidenciasStreamlined.vue?vue&type=script&lang=ts"

import "./IncidenciasStreamlined.vue?vue&type=style&index=0&id=772c10ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-772c10ca"

export default script